import { UseQueryResult } from '@tanstack/react-query';
import { useSession } from '../SessionProvider';
import { getAllGroups, getShareGroups, Group } from './getGroups';
import { useTrackedQuery as useQuery } from '@ais-ui/performance-tracking';

export const useGetShareGroups = (): UseQueryResult<Group[]> => {
  const { olSession, sessionId } = useSession();

  return useQuery(
    {
      queryKey: ['getShareGroups'],
      queryFn: () => {
        return getShareGroups(olSession);
      },
      enabled: !!sessionId,
    },
    'groups:getShare',
  );
};

export const useGetAllGroups = (): UseQueryResult<Group[]> => {
  const { olSession, sessionId } = useSession();

  return useQuery(
    {
      queryKey: ['getAllGroups'],
      queryFn: () => {
        return getAllGroups(olSession);
      },
      enabled: !!sessionId,
    },
    'groups:getAll',
  );
};
